import * as client from './client';

export const ADS_STANDARD_PLAN = 'x_ads_standard';
export const ADS_PROSPECTING_PLAN = 'x_ads_prospecting';
export const PLATFORM_ADDON_ACQUISITIONS_PLAN = 'platform_addon_acquisitions';

export function switchAccount(accountId) {
  if (accountId === 'new-team') {
    client.navigateToNewTeams();
    return;
  }

  client.switchAccount(accountId).then(() => {
    window.location = '/';
  });
}
